(() => {
  if (window.NarivieArabicSearch) { window.NarivieArabicSearch(); return; }
  const dictionary = document.querySelector('script[data-nv-search-dictionary]')?.dataset.nvSearchDictionary;
  const normalize = value => String(value || '').toLowerCase().replace(/[\u064b-\u065f\u0640]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').replace(/\s+/g, ' ').trim();
  let pending;
  const load = () => pending ||= fetch(dictionary, { credentials: 'same-origin' }).then(response => { if (!response.ok) throw new Error('dictionary'); return response.json(); });
  const boot = () => document.querySelectorAll('form[action*="/search"]').forEach(form => {
    const input = form.querySelector('input[name="q"]');
    if (!input || form.dataset.nvSearchReady || !dictionary) return;
    form.dataset.nvSearchReady = 'true';
    const original = new URLSearchParams(location.search).get('nv_q');
    if (original) input.value = original;
    form.addEventListener('submit', async event => {
      const term = input.value.trim();
      if (!/[\u0600-\u06ff]/.test(term)) return;
      event.preventDefault();
      try {
        const data = await load(), words = normalize(term).split(' ').filter(Boolean);
        const matches = data.filter(product => words.every(word => normalize(product.ar).includes(word))).slice(0, 12);
        const target = new URL(form.action, location.origin);
        target.searchParams.set('type', 'product');
        target.searchParams.set('nv_q', term);
        target.searchParams.set('q', matches.length ? matches.map(product => 'title:"' + product.fr.replace(/"/g, '') + '"').join(' OR ') + ' OR ' + term : term);
        location.assign(target.href);
      } catch (_) { HTMLFormElement.prototype.submit.call(form); }
    });
  });
  window.NarivieArabicSearch = boot;
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
